import React from 'react';
import { Layout, Flex, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import AgentSelect from '../AgentSelect/AgentSelect';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';
import SharedFilterBar from '../../../Shared/Filters/SharedFilterBar';
import { conversationFilterFields } from '../../../Shared/Filters/filterConfig';
import './ConversationsHeader.css';

const { Header } = Layout;

const ConversationsHeader = ({
    agents,
    loadingAgents,
    selectedAgent,
    onAgentChange,
    onAgentSearch,
    onSearch,
    loading,
    filters,
    onFiltersChange,
    sortValue,
    onSortChange,
}) => {
    const { isDarkMode } = useTheme();
    const { t } = useTranslation();
    const themeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        border: isDarkMode ? '#434343' : '#f0f0f0',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)',
        hoverBg: isDarkMode ? '#2a2a2a' : '#fafafa',
    };

    return (
        <Header style={{
            padding: '8px',
            height: 'auto',
            lineHeight: 'normal',
            background: themeColors.background,
            borderBottom: `1px solid ${themeColors.border}`,
            transition: 'background 0.3s ease, border-color 0.3s ease'
        }}>
            {/* Agent Select */}
            <AgentSelect
                agents={agents}
                loading={loadingAgents}
                value={selectedAgent}
                onChange={onAgentChange}
                onSearch={onAgentSearch}
                isDarkMode={isDarkMode}
            />

            {/* Search + Shared Filters + Reset */}
            <Flex
                wrap
                align="center"
                justify="space-between"
                style={{ marginTop: 10, gap: 8 }}
            >
                <Input.Search
                    placeholder={t('search_by_contact_name')}
                    style={{
                        flex: 1,
                        minWidth: 160,
                        backgroundColor: isDarkMode ? '#141414' : '#fff',
                        borderColor: themeColors.border,
                        color: themeColors.text
                    }}
                    onChange={onSearch}
                    loading={loading}
                    allowClear
                />

                <div className="conversation-filter-scroll">
                    <SharedFilterBar
                        fields={conversationFilterFields}
                        value={filters}
                        onChange={onFiltersChange}
                        sortFields={[
                            { value: 'updated_time', labelKey: 'filters_field_last_activity' },
                            { value: 'created_at', labelKey: 'created_at' },
                            { value: 'updated_at', labelKey: 'updated_at' },
                            { value: 'status', labelKey: 'filters_field_status' },
                            { value: 'contact_name', labelKey: 'full_name' },
                        ]}
                        sortValue={sortValue}
                        onSortChange={onSortChange}
                    />
                </div>
            </Flex>
        </Header>
    );
};

export default ConversationsHeader;
